import {
  DataEntryStepProps,
  FormikCoherenceQuestion,
  typedMemo,
} from "src/types";
import { useDataEntryStep3 } from "./data-entry-step-3.hook";
import { InputRadio, Loader } from "src/ui/widgets";
import { FormikErrors } from "formik";
import { ResumePurchase } from "src/ui/fragments";
import { WarningIcon } from "src/assets";
import { Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

export const DataEntryStep3 = typedMemo(
  ({ formik, validationSchema }: DataEntryStepProps) => {
    const {
      values: { coherenceQuestions },
      handleChange,
      handleBlur,
      touched,
      errors,
    } = formik;

    const {
      isDesktop,
      showQuestionnaireFailure,
      continueDisabled,
      getQuestionnairePending,
      t,
    } = useDataEntryStep3(formik);

    const Title = (
      <>
        <div className="mb-2 font-medium-m">{t("data_entry_step_3.title")}</div>
        <p className="font-14-light c-7f7f7f ">
          {t("data_entry_step_3.subtitle")}
        </p>
      </>
    );

    const Questions = (
      <div className="mt-4">
        {coherenceQuestions &&
          coherenceQuestions?.length > 0 &&
          coherenceQuestions.map(
            (question: FormikCoherenceQuestion, index: number) => {
              const errorsC = errors.coherenceQuestions?.[
                index
              ] as FormikErrors<FormikCoherenceQuestion>;

              return (
                <div key={question.id}>
                  <InputRadio
                    name={`coherenceQuestions.${index}.answer`}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    options={question.options}
                    validationSchema={
                      validationSchema?.fields?.coherenceQuestions?.innerType
                    }
                    touched={!!touched.coherenceQuestions?.[index]}
                    value={coherenceQuestions?.[index].answer}
                    error={
                      typeof errorsC?.answer === undefined
                        ? ""
                        : errorsC?.answer
                    }
                    label={question.label}
                    classes="m-0 ps-0"
                    classesLabel="m-0 p-0 font-16-light d-flex align-items-center mb-3"
                  />
                </div>
              );
            }
          )}
      </div>
    );

    const UnsuitableModal = (
      <div
        id="unsuitable-modal"
        className="bg-e5f0f1 mt-3 d-flex gap-3 p-2 rounded"
      >
        <div className="align-content-md-center justify-content-center">
          <Image className="filter-00686F" src={WarningIcon} />
        </div>
        <div>
          <div className="font-medium-s mb-1">
            {t("data_entry_step_3.unsuitable_purchase_warning")}
          </div>
          <div className="font-14-light">
            {t("data_entry_step_3.unsuitable_purchase_description")}
          </div>
        </div>
      </div>
    );

    //Note: Change this to match the structure of Questtionaire component
    const SkeletonLoader = (
      <div className="d-flex gap-4">
        <div className="col-sm-12 col-xl-8">
          <Skeleton count={1} height={"100%"} />
        </div>
        <div
          className="d-xl-block d-none col"
          style={{
            minHeight: "680px",
          }}
        >
          {isDesktop && <Skeleton count={1} height={"100%"} />}
        </div>
      </div>
    );

    return (
      <>
        {getQuestionnairePending && (
          <div className="m-auto d-flex justify-content-center mb-3">
            <Loader overlay />
          </div>
        )}
        {getQuestionnairePending ? (
          SkeletonLoader
        ) : (
          <div className="d-flex gap-4">
            <div className="col-sm-12 col-xl-8">
              <div
                className="bg-white border rounded p-5"
                style={{ height: "fit-content" }}
              >
                {Title}
                {Questions}
              </div>
              {showQuestionnaireFailure && UnsuitableModal}
            </div>
            <div
              className="d-xl-block d-none col"
              style={{
                minHeight: "680px",
              }}
            >
              {isDesktop && (
                <ResumePurchase
                  formik={formik}
                  continueDisabled={continueDisabled}
                />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
);
